<!-- 由 suu 创建于 2022-01-06 星期四 -->
<!-- 营期档案 APP 小程序都可接入 -->
<template>
  <div class="camp-archives">
    <!-- 顶部筛选 -->
    <the-header
      @on-search="handelSearch"
      @on-change="handelChange"
    ></the-header>
    <div class="ca-tips" v-if="!loading && total">
      共筛出{{ total }}个班级
    </div>
    <!-- 列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getInfo"
    >
      <archive-item
        :info="item"
        v-for="(item, index) in list"
        :key="index"
      ></archive-item>
    </van-list>
  </div>
</template>

<script>
import TheHeader from './ponents/TheHeader.vue'
import ArchiveItem from './ponents/ArchiveItem.vue'
export default {
  name: 'camp-archives',

  components: { TheHeader, ArchiveItem },

  props: {},

  data() {
    return {
      seData: {
        fid: '', // 营期ID
        pid: '', // 班级id
        cid: '', // 营养师
        status: 0, // 状态 0-全部 1-未开始 2-进行中 3-已结束
        order: '', // 筛选 Key
        order_type: '' // 排序 asc-低到高 desc-高到低
      },
      keyword: '', // 搜索
      page: 1, // 当前页数
      loading: false, // 列表加载中状态
      finished: false, // 列表加载完
      list: [],
      total: 0 // 当前筛选总共
    }
  },

  computed: {},

  watch: {},

  created() {
    wx.miniProgram.getEnv((res) => {
      this.isMini = res.miniprogram
    })
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 顶部筛选
     */
    handelChange(data) {
      this.seData = data
      this.page = 1
      this.finished = false
      this.list = []
      this.loading = true //手动获取数据时需要禁止list组件的自动加载
      this.getInfo()
    },
    /**
     * 顶部搜索
     */
    handelSearch(str) {
      this.keyword = str
    },
    /**
     * 获取信息
     */
    getInfo() {
      const param = {
        keyword: this.keyword,
        page: this.page, // 页数
        ...this.seData
      }
      this.$http
        .getApp('member/AppCampCoach/getTjData', param)
        .then((res) => {
          if (res.data.code == 200) {
            const info = res.data.data
            this.total = info.total
            this.list = this.list.concat(info.data)
            if (info.current_page < info.last_page) {
              this.page++
            } else {
              this.finished = true
            }
          } else {
            this.$notify({ type: 'danger', message: res.data.msg })
            this.finished = true
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.finished = true
          this.$notify({ type: 'danger', message: '网络错误' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.camp-archives {
  width: 100vw;
  box-sizing: border-box;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f7f7f7;
  padding-bottom: 20px;
  padding-bottom: constant(safe-area-inset-bottom); //兼容 IOS<11.2
  padding-bottom: env(safe-area-inset-bottom); //兼容 IOS>11.2
  .ca-tips {
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    margin-top: 16px;
    font-size: 12px;
    color: #7b7b7b;
  }
}
</style>
